import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/Landing',
  },
  {
    path: '/',
    name: 'Layout',
    redirect: '/Landing',
    component: () => import('@/views/Register/Layout.vue'),

    children: [
      {
        path: 'Landing',
        name: 'Landing',
        component: () => import('@/views/Register/Landing.vue'),
        meta: {
          title: 'Landing - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
        },
      },

      {
        path: 'Login',
        name: 'Login',
        component: () => import('@/views/Register/Login.vue'),
        meta: {
          title: 'Login - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'Signup',
        name: 'Signup',
        component: () => import('@/views/Register/Signup.vue'),
        meta: {
          title: 'Signup - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'Registration',
        name: 'Registration',
        component: () => import('@/views/Register/Registration.vue'),
        meta: {
          title: 'Registration - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'Home',
        name: 'Home',
        component: () => import('@/views/Home/Home.vue'),
        meta: {
          title: 'Home - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'PressReleases/Page=:NewsPage',
        name: 'PressReleases',
        component: () => import('@/views/Home/PressReleases.vue'),
        meta: {
          title: 'PressReleases - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'Products/Page=:ProductPage',
        name: 'Products',
        component: () => import('@/views/Home/Products.vue'),
        meta: {
          title: 'Products - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'ProductDetail/:MyProId',
        name: 'ProductDetail',
        component: () => import('@/views/Home/ProductDetail.vue'),
        meta: {
          title: 'ProductDetail - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'Videos/Page=:VideoPage',
        name: 'Videos',
        component: () => import('@/views/Home/Videos.vue'),
        meta: {
          title: 'Videos - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'ExhibitorDetail/:MyExhId',
        name: 'ExhibitorDetail',
        component: () => import('@/views/Home/ExhibitorDetail.vue'),
        meta: {
          title: 'ExhibitorDetail - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'Exhibitors/Page=:Page',
        name: 'Exhibitors',
        component: () => import('@/views/Home/Exhibitors.vue'),
        meta: {
          title: 'Exhibitors - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'FavoriteExhibitors/Page=:FavExhPage',
        name: 'FavoriteExhibitors',
        component: () => import('@/views/Home/FavoriteExhibitors.vue'),
        meta: {
          title: 'FavoriteExhibitors - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'FavoriteProducts/Page=:FavProPage',
        name: 'FavoriteProducts',
        component: () => import('@/views/Home/FavoriteProducts.vue'),
        meta: {
          title: 'FavoriteProducts - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'Edit',
        name: 'Edit',
        component: () => import('@/views/Home/Edit.vue'),
        meta: {
          title: 'Edit - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'AdvanceSearchExhibitors/Page=:SearchExhPage',
        name: 'AdvanceSearchExhibitors',
        component: () => import('@/views/Home/AdvanceSearchExhibitors.vue'),
        meta: {
          title:
            'AdvanceSearchExhibitors - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'AdvanceSearchProducts/Page=:SearchProPage',
        name: 'AdvanceSearchProducts',
        component: () => import('@/views/Home/AdvanceSearchProducts.vue'),
        meta: {
          title:
            'AdvanceSearchProducts - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'PressReleaseDetail/:MyNewsId',
        name: 'PressReleaseDetail',
        component: () => import('@/views/Home/PressReleaseDetail.vue'),
        meta: {
          title: 'PressReleaseDetail - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'OfficialNewsDetail/:MyLastedNewsId',
        name: 'OfficialNewsDetail',
        component: () => import('@/views/Home/OfficialNewsDetail.vue'),
        meta: {
          title: 'OfficialNewsDetail - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'BrowsingHistoryExhibitors/Page=:HisExhPage',
        name: 'BrowsingHistoryExhibitors',
        component: () => import('@/views/Home/BrowsingHistoryExhibitors.vue'),
        meta: {
          title:
            'BrowsingHistoryExhibitors - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'BrowsingHistoryProducts/Page=:HisProPage',
        name: 'BrowsingHistoryProducts',
        component: () => import('@/views/Home/BrowsingHistoryProducts.vue'),
        meta: {
          title:
            'BrowsingHistoryProducts - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'Events',
        name: 'Events',
        component: () => import('@/views/Home/Events.vue'),
        meta: {
          title: 'Online Events - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'Association',
        name: 'Association',
        component: () => import('@/views/Home/Association.vue'),
        meta: {
          title: 'Association Center - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'AssociationDetail/:MyAssoId',
        name: 'AssociationDetail',
        component: () => import('@/views/Home/AssociationDetail.vue'),
        meta: {
          title: 'AssociationDetail - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },

      {
        path: 'ProductLaunch',
        name: 'ProductLaunch',
        component: () => import('@/views/Home/ProductLaunch.vue'),
        meta: {
          title: 'Product Launch - Vietnam International Plastics & Rubber Industry Exhibition | Online Exhibition',
          requiresAuth: true,
        },
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: '/vietnamplasprintpack/onlineexpo/',
  routes,

  scrollBehavior(to, from, savedPosition) {
    if (to.name !== 'Home') {
      if (savedPosition) {
        setTimeout(() => {
          window.scrollTo(savedPosition.x, savedPosition.y)
        }, 200)
      }
    } else {
      return { x: 0, y: 0 }
    }
  },
})

export default router
